import { render, staticRenderFns } from "./ProjectBox.vue?vue&type=template&id=535a2359&"
import script from "./ProjectBox.vue?vue&type=script&lang=js&"
export * from "./ProjectBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports